"use strict";
/**
 * @name Loader
 *
 * @description
 *  A loader component that supports different animations such as Spin, Pulse and Jello.  See the teamsnap patterns
 *  library for more information https://teamsnap-ui-patterns.netlify.com/patterns/components/loader.html
 *
 * @example
 *  <Loader type='jello' text='loading' />
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var helpers_1 = require("../../utils/helpers");
var propTypes = {
    type: PropTypes.oneOf(['jello', 'pulse', 'spin']).isRequired,
    text: PropTypes.string,
    message: PropTypes.string,
    className: PropTypes.string,
    mods: PropTypes.string,
    style: PropTypes.object,
    testId: PropTypes.string,
    otherProps: PropTypes.object,
    size: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number,
    }),
};
var Loader = function (_a) {
    var type = _a.type, text = _a.text, message = _a.message, className = _a.className, mods = _a.mods, style = _a.style, testId = _a.testId, otherProps = _a.otherProps, size = _a.size;
    var renderSpinAnimation = function () { return React.createElement("span", { style: __assign({}, size), className: "SpinAnimation" }); };
    var renderPulseAnimation = function () { return (React.createElement("span", { className: "PulseAnimation" },
        React.createElement("span", { style: __assign({}, size), className: "PulseAnimation-dot" }),
        React.createElement("span", { style: __assign({}, size), className: "PulseAnimation-dot" }),
        React.createElement("span", { style: __assign({}, size), className: "PulseAnimation-dot" }))); };
    var renderJelloAnimation = function () {
        // These numbers are base on the JelloAnimation container size of 40 as well as the
        // ratio between the container size and the default animation size of 32 which is 0.2
        var width = 32;
        var offset = 4;
        var containerRatio = 0.2;
        if (size) {
            offset = Math.ceil((size === null || size === void 0 ? void 0 : size.width) / 8);
            width = size === null || size === void 0 ? void 0 : size.width;
        }
        var containerSize = (containerRatio * width) + width;
        return (React.createElement("span", { className: "JelloAnimation", style: { width: containerSize, height: containerSize } },
            React.createElement("span", { style: {
                    width: width,
                    height: offset,
                    bottom: -offset,
                }, className: "JelloAnimation-shadow" }),
            React.createElement("span", { style: __assign({}, size), className: "JelloAnimation-box" })));
    };
    var renderAnimation = function (animation) {
        if (animation === 'jello') {
            return renderJelloAnimation();
        }
        if (animation === 'pulse') {
            return renderPulseAnimation();
        }
        return renderSpinAnimation();
    };
    if (!text && !message) {
        return renderAnimation(type);
    }
    var loaderClasses = (0, helpers_1.getClassName)(className, type === 'jello' && 'Loader--jello', mods);
    return (React.createElement("div", __assign({ className: loaderClasses, style: style, "data-testid": testId }, otherProps),
        React.createElement("div", { className: "Loader-indicator" },
            renderAnimation(type),
            text && React.createElement("div", { className: "Loader-indicatorText" }, text)),
        message && React.createElement("div", { className: "Loader-message" }, message)));
};
Loader.defaultProps = {
    text: null,
    message: null,
    className: 'Loader',
    mods: null,
    style: {},
    testId: null,
    otherProps: {},
};
exports.default = Loader;
